export default __webpack_public_path__ + "static/media/initialized.c1ffafe6.png";